module.exports={render:function (){with(this) {
  return _h('div', [_h('table', {
    attrs: {
      "id": "head"
    }
  }, [_h('tr', [_m(0), " ", _m(1), " ", _h('td', [_h('editable', {
    attrs: {
      "id": ("place-" + _uid)
    },
    domProps: {
      "value": invoice.place
    },
    on: {
      "change": function($event) {
        invoice.place = $event
      }
    }
  })])]), " ", _h('tr', [_m(2), " ", _m(3), " ", _h('td', [_h('editable', {
    attrs: {
      "date": "",
      "id": ("date-" + _uid)
    },
    domProps: {
      "value": invoice.date
    },
    on: {
      "change": function($event) {
        invoice.date = $event
      }
    }
  })])]), " ", _h('tr', [_m(4), " ", _m(5), " ", _h('td', [_h('editable', {
    attrs: {
      "date": "",
      "id": ("deliveryDate-" + _uid)
    },
    domProps: {
      "value": invoice.deliveryDate
    },
    on: {
      "change": function($event) {
        invoice.deliveryDate = $event
      }
    }
  })])])]), " ", _h('section', {
    attrs: {
      "id": "seller"
    }
  }, [_m(6), " ", _h('p', [_h('editable', {
    attrs: {
      "multiline": "",
      "id": ("seller-" + _uid)
    },
    domProps: {
      "value": invoice.seller
    },
    on: {
      "change": function($event) {
        invoice.seller = $event
      }
    }
  })])]), " ", _h('section', {
    attrs: {
      "id": "buyer"
    }
  }, [_m(7), " ", _h('p', [_h('editable', {
    attrs: {
      "multiline": "",
      "id": ("buyer-" + _uid)
    },
    domProps: {
      "value": invoice.buyer
    },
    on: {
      "change": function($event) {
        invoice.buyer = $event
      }
    }
  })])]), " ", _h('h1', [_h('editable', {
    attrs: {
      "id": ("title-" + _uid)
    },
    domProps: {
      "value": invoice.title
    },
    on: {
      "change": function($event) {
        invoice.title = $event
      }
    }
  })]), " ", _h('h2', [_h('editable', {
    attrs: {
      "id": ("id-" + _uid)
    },
    domProps: {
      "value": invoice.id
    },
    on: {
      "change": function($event) {
        invoice.id = $event
      }
    }
  })]), " ", _h('table', {
    attrs: {
      "id": "products"
    }
  }, [_m(8), " ", _h('products', {
    attrs: {
      "id": "product-list",
      "products": invoice.products
    },
    on: {
      "remove": removeProduct,
      "change": changeProduct
    }
  }), " ", _h('products-summary', {
    attrs: {
      "id": "summary",
      "products": invoice.products
    },
    on: {
      "new": newProduct
    }
  }), " ", _h('products-total', {
    attrs: {
      "id": "total",
      "products": invoice.products
    }
  })]), " ", _h('table', {
    attrs: {
      "id": "foot"
    }
  }, [_h('tbody', [_h('tr', [_m(9), " ", _m(10), " ", _h('td', [_s(money(total)) + " ", _m(11)])]), " ", _h('tr', [_m(12), " ", _m(13), " ", _h('td', [_h('editable', {
    attrs: {
      "date": "",
      "id": ("paymentDate-" + _uid)
    },
    domProps: {
      "value": invoice.paymentDate
    },
    on: {
      "change": function($event) {
        invoice.paymentDate = $event
      }
    }
  })])]), " ", _h('tr', [_m(14), " ", _m(15), " ", _h('td', [_h('editable', {
    attrs: {
      "id": ("paymentType-" + _uid)
    },
    domProps: {
      "value": invoice.paymentType
    },
    on: {
      "change": function($event) {
        invoice.paymentType = $event
      }
    }
  })])]), " ", (invoice.footer) && _l((invoice.footer), function(f, idx) {
    return _h('tr', {
      key: f.id,
      class: {
        empty: f.name === ''
      }
    }, [_h('th', [_h('button', {
      on: {
        "click": function($event) {
          removeFooter(idx)
        }
      }
    }, ["Usuń"]), _h('editable', {
      attrs: {
        "id": ("footer-name-" + idx + "-" + _uid)
      },
      domProps: {
        "value": f.name
      },
      on: {
        "change": function($event) {
          f.name = $event
        }
      }
    })]), " ", _m(16, true), " ", _h('td', [_h('editable', {
      attrs: {
        "id": ("footer-value-" + idx + "-" + _uid)
      },
      domProps: {
        "value": f.value
      },
      on: {
        "change": function($event) {
          f.value = $event
        }
      }
    })])])
  })]), " ", _h('tbody', [_h('tr', [_h('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_h('button', {
    on: {
      "click": function($event) {
        addFooter()
      }
    }
  }, ["Dodaj"])])])])]), " ", _h('section', {
    staticClass: "signature"
  }, [_h('p', [_h('editable', {
    attrs: {
      "id": ("buyerSignature-" + _uid)
    },
    domProps: {
      "value": invoice.buyerSignature
    },
    on: {
      "change": function($event) {
        invoice.buyerSignature = $event
      }
    }
  })]), " ", _m(17)]), " ", _h('section', {
    staticClass: "signature"
  }, [_h('p', [_h('editable', {
    attrs: {
      "id": ("sellerSignature-" + _uid)
    },
    domProps: {
      "value": invoice.sellerSignature
    },
    on: {
      "change": function($event) {
        invoice.sellerSignature = $event
      }
    }
  })]), " ", _m(18)])])
}},staticRenderFns: [function (){with(this) {
  return _h('th', ["Miejsce wystawienia"])
}},function (){with(this) {
  return _h('td', [":"])
}},function (){with(this) {
  return _h('th', ["Data wystawienia"])
}},function (){with(this) {
  return _h('td', [":"])
}},function (){with(this) {
  return _h('th', ["Data wykonania usługi"])
}},function (){with(this) {
  return _h('td', [":"])
}},function (){with(this) {
  return _h('h3', ["Sprzedawca"])
}},function (){with(this) {
  return _h('h3', ["Nabywca"])
}},function (){with(this) {
  return _h('thead', [_h('tr', [_h('td', [_h('span', ["Lp"])]), " ", _h('td', [_h('span', ["Nazwa usługi"])]), " ", _h('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_h('span', ["Ilość", _h('br'), "J.m."])]), " ", _h('td', {
    staticClass: "number"
  }, [_h('span', ["Cena netto", _h('small', ["[PLN]"])])]), " ", _h('td', {
    staticClass: "number"
  }, [_h('span', ["VAT", _h('small', ["[%]"])])]), " ", _h('td', {
    staticClass: "number"
  }, [_h('span', ["Wartość netto", _h('small', ["[PLN]"])])]), " ", _h('td', {
    staticClass: "number"
  }, [_h('span', ["Wartość VAT", _h('small', ["[PLN]", _h('small')])])]), " ", _h('td', {
    staticClass: "number"
  }, [_h('span', ["Wartość brutto", _h('small', ["[PLN]"])])])])])
}},function (){with(this) {
  return _h('th', ["Do zapłaty"])
}},function (){with(this) {
  return _h('td')
}},function (){with(this) {
  return _h('small', ["PLN"])
}},function (){with(this) {
  return _h('th', ["Termin płatności"])
}},function (){with(this) {
  return _h('td')
}},function (){with(this) {
  return _h('th', ["Forma płatności"])
}},function (){with(this) {
  return _h('td')
}},function (){with(this) {
  return _h('td')
}},function (){with(this) {
  return _h('small', ["Imię, nazwisko i podpis osoby uprawnionej do odbioru dokumentu"])
}},function (){with(this) {
  return _h('small', ["Podpis osoby uprawnionej do wystawienia dokumentu"])
}}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Invoices/Add.vue
 ** module id = 169
 ** module chunks = 2
 **/